"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalorieCountDay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const structural_organisms_1 = require("../structural-organisms");
const CollapseMeal_1 = require("./CollapseMeal");
const NutrientsDayProgress_1 = require("./NutrientsDayProgress");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const CollapseMealHandpalm_1 = __importDefault(require("./CollapseMealHandpalm"));
const renderNutritionDay = (nutritionDayItemsData) => {
    return nutritionDayItemsData.map((item, index) => {
        if (item.method === "handpalm") {
            return ((0, jsx_runtime_1.jsx)(CollapseMealHandpalm_1.default, { meal: item.meal }, item.meal.name + index));
        }
        return ((0, jsx_runtime_1.jsx)(CollapseMeal_1.CollapseMeal, { meal: item.meal, unit: item.unit, method: item.method, translations: item.translations }, item.meal.name + index));
    });
};
const renderNutritionItems = (items, _isMobile, messageForEmptyList) => {
    if (items.length > 0)
        return renderNutritionDay(items);
    return [
        (0, jsx_runtime_1.jsx)(EmptyListPlaceholderWrapper, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: messageForEmptyList }, void 0) }, 0)
    ];
};
const CalorieCountDay = (props) => {
    return ((0, jsx_runtime_1.jsx)(structural_organisms_1.ListWithMargin, { children: [
            (0, jsx_runtime_1.jsx)(NutrientsDayProgress_1.NutrientsDayProgress, { day: props.progressCompositionProps.nutritionDay, translations: {
                    progressBoxTranslations: props.progressCompositionProps.translations.progressTranslations,
                    webTranslations: props.progressCompositionProps.translations
                        .webComponentTranslations
                }, onLinkClick: props.progressCompositionProps.onLinkClick, unit: props.progressCompositionProps.unit, sharedValues: {
                    caloriesValue: props.progressCompositionProps.budgetCaloriesValue
                } }, "Progress"),
            ...renderNutritionItems(props.nutritionDayItemsData, props.isMobile, props.emptyListMessage)
        ] }, void 0));
};
exports.CalorieCountDay = CalorieCountDay;
const EmptyListPlaceholderWrapper = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.spacings.xl};

  p {
    margin-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-left: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=CaloriecountDay.js.map